import React, { useState } from "react";
// Material Ui

import MuiTextField from "@mui/material/TextField";
import { InputProps } from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import Favorite from "@mui/icons-material/Favorite";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { inputSxPropsFn, inputLabelSxPropsFn } from "./TextField.styles";

import { CustomTextFieldProps } from "./types";

const TextField = ({
  type = "text",
  masked,
  name,
  frontAdornment,
  endAdornment,
  endAdornmentClick,
  multiline = false,
  inputSize = "medium",
  defaultAdornmentColors = true,
  ...rest
}: CustomTextFieldProps): JSX.Element => {
  const inputProps = {} as InputProps;

  // Get padding and fontsize per inputSize
  const sizeData = (() => {
    if (inputSize === "large") {
      return {
        padding: "16.5px",
        fontSize: "16px",
        legend: "12px",
        label: "16px",
      };
    }
    if (inputSize === "medium") {
      return {
        padding: "11px",
        fontSize: "16px",
        legend: "12px",
        label: "11px",
      };
    }
    return {
      padding: "8px",
      fontSize: "16px",
      legend: "12px",
      label: "7px",
    };
  })();

  inputProps.sx = inputSxPropsFn({
    sizeData,
    defaultAdornmentColors,
    multiline,
  });

  /**
   * Masking input logic
   */
  const [showField, setShowField] = useState(false);
  const handleClickShowPassword = (): void => {
    setShowField(!showField);
  };
  const handleMouseDefault = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    e.preventDefault();
  };
  // End Mask logic

  /**
   * if masked field is set, show eye icon
   */
  if (masked) {
    inputProps.endAdornment = (
      <InputAdornment position="end">
        <IconButton
          data-testid="adornment-masked-toggle"
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDefault}
        >
          {showField ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    );
  } else if (endAdornment) {
    /**
     * If endAdornment is passed set endAdornment
     */
    inputProps.endAdornment = (
      <InputAdornment position="end">
        <IconButton
          data-testid="adornment-end"
          aria-label="adornment input end"
          onMouseDown={handleMouseDefault}
          onClick={endAdornmentClick}
        >
          {endAdornment}
        </IconButton>
      </InputAdornment>
    );
  }
  /**
   * If front adornment is set, either show provided node or default heart
   */
  if (frontAdornment) {
    const adornment = frontAdornment === true ? <Favorite /> : frontAdornment;
    inputProps.startAdornment = (
      <InputAdornment position="start">{adornment}</InputAdornment>
    );
  }
  const testid = name || type;
  const inputLabelProps = {
    sx: inputLabelSxPropsFn({ sizeData }),
  };
  return (
    <MuiTextField
      InputLabelProps={inputLabelProps}
      type={!showField && masked ? "password" : type}
      InputProps={inputProps}
      multiline={multiline}
      data-testid={`input-${testid}`}
      {...rest}
    />
  );
};

export default TextField;
